import React from "react";
import PropTypes from "prop-types";
import { ArrowRight } from "lucide-react";

// Color mapping for service cards
const colorClasses = {
  rose: "bg-rose-50 dark:bg-rose-900/20 text-rose-600 dark:text-rose-400 group-hover:bg-rose-600",
  pink: "bg-pink-50 dark:bg-pink-900/20 text-pink-600 dark:text-pink-400 group-hover:bg-pink-600",
  amber:
    "bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 group-hover:bg-amber-600",
  purple:
    "bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400 group-hover:bg-purple-600",
  blue: "bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 group-hover:bg-blue-600",
  indigo:
    "bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 group-hover:bg-indigo-600",
  red: "bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 group-hover:bg-red-600",
  slate:
    "bg-slate-100 dark:bg-slate-700/50 text-slate-600 dark:text-slate-400 group-hover:bg-slate-600",
  cyan: "bg-cyan-50 dark:bg-cyan-900/20 text-cyan-600 dark:text-cyan-400 group-hover:bg-cyan-600",
  teal: "bg-teal-50 dark:bg-teal-900/20 text-teal-600 dark:text-teal-400 group-hover:bg-teal-600",
  yellow:
    "bg-yellow-50 dark:bg-yellow-900/20 text-yellow-600 dark:text-yellow-400 group-hover:bg-yellow-600",
  emerald:
    "bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 group-hover:bg-emerald-600",
  orange:
    "bg-orange-50 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 group-hover:bg-orange-600",
  violet:
    "bg-violet-50 dark:bg-violet-900/20 text-violet-600 dark:text-violet-400 group-hover:bg-violet-600",
};

const ServiceCard = (props) => {
  const { service, bookingHandler } = props;
  const Icon = service.icon;
  const colorClass = colorClasses[service.color] || colorClasses.blue;

  return (
    <div
      id={service.id}
      className="group relative bg-white dark:bg-slate-800 rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 border border-slate-100 dark:border-slate-700 flex flex-col h-full hover:-translate-y-1"
    >  {/* Icon Area */}
      <div className="pt-10 pb-6 px-8 flex justify-center">
        <div
          className={`p-6 rounded-2xl transition-all duration-300 group-hover:text-white group-hover:scale-110 ${colorClass}`}
        >
          {Icon && <Icon size={48} strokeWidth={1.5} />}
        </div>
      </div>

      {/* Content Area */}
      <div className="px-8 pb-8 flex flex-col flex-grow text-center">
        <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-3 font-serif">
          {service.title}
        </h3>
        <p className="text-slate-600 dark:text-slate-400 mb-6 line-clamp-3 text-base leading-relaxed flex-grow">
          {service.description}
        </p>

        <button
          onClick={() => bookingHandler(service)}
          className="mt-auto w-full py-4 rounded-xl bg-slate-50 dark:bg-slate-700/50 text-blue-600 dark:text-blue-400 font-bold group-hover:bg-blue-600 group-hover:text-white transition-all flex items-center justify-center gap-2"
        >
          Book Experience <ArrowRight size={18} />
        </button>
      </div>
    </div>
  );
};

ServiceCard.propTypes = {
  service: PropTypes.object.isRequired,
  bookingHandler: PropTypes.func.isRequired,
};

export default ServiceCard;
